<template>
  <div class="h-full">
    <el-scrollbar style="height: calc(100% - 36px);">
      <el-form
        ref="formRef"
        require-asterisk-position="right"
        label-position="top"
        :model="formValues"
        :rules="rules"
      >
        <div class="base-card-info c-auto ">
          <div class="info-card-title">
            绑定银行卡
          </div>
          <div style="display: flex">
            <div class="flex-1">
              <el-form-item prop="bankAccountType" :label="isEnterpriseAgent?'银行账户类型':'企业基本账户类型'">
                <el-select
                  v-model="formValues.bankAccountType"
                  placeholder="请选择"
                  clearable
                  class="w-[80%] "
                >
                  <el-option
                    v-for="v in bankTypeOptions"
                    :key="v.value"
                    :value="v.value"
                    :label="v.label"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item prop="bankCardNo" :label="isEnterpriseAgent?'银行账号':'企业基本账号'">
                <el-input
                  v-model="formValues.bankCardNo"
                  class="w-[80%] h-[40px]"
                  clearable
                  autocomplete="nony"
                  placeholder="请输入"
                />
              </el-form-item>
            </div>
          </div>
          <div style="display: flex">
            <div class="flex-1">
              <el-form-item prop="bankAccountName" :label="isEnterpriseAgent?'企业基本账户名':'企业基本账户名'">
                <el-input
                  v-model="formValues.bankAccountName"
                  class="w-[80%] h-[40px]"
                  clearable
                  autocomplete="nony"
                  placeholder="请输入"
                />
              </el-form-item>
            </div>
            <div class="flex-1" />
          </div>
          <div>
            <!-- 选择开户行 -->
            <el-form-item label="开户银行" required style="height: 10px;">
      &nbsp;
            </el-form-item>
            <div class="flex w-full items-center acc-one-row">
              <el-form-item prop="bankCode">
                <el-select
                  v-model="formValues.bankCode"
                  class="w-[160px] "
                  clearable
                  filterable
                  placeholder="请搜索并选择开户银行"
                  autocomplete="noy"
                  remote
                  :loading="queryingMasterBanks"
                  :remote-method="searchMasterBanks"
                  @change="selectBasicBank"
                >
                  <el-option
                    v-for="item in basicBankList"
                    :key="item.bankCode"
                    :label="item.bankName"
                    :value="item.bankCode"
                  />
                </el-select>
              </el-form-item>
              <el-form-item prop="bankCityCode" class="!w-[300px] ml-4">
                <area-select
                  :initial-codes="initialAreaCodes"
                  :enable-town="false"
                  prov-placeholder="请选择开户省份"
                  city-placeholder="请选择开户城市"
                  @change="(vals: string[]) => {
                    formValues.bankProvinceCode = vals[0];
                    formValues.bankCityCode = vals[1];
                    onCityChange();
                  }"
                />
              </el-form-item>
              <el-form-item v-if="!customWriteBranchBank" prop="bankBranchNo">
                <el-select
                  v-model="formValues.bankBranchNo"
                  class="w-[360px] ml-4"
                  filterable
                  clearable
                  autocomplete="noy"
                  remote
                  placeholder="输入关键字搜索并选择开户支行"
                  :loading="queryingSubBanks"
                  :remote-method="queryBankBranchSearch"
                  @change="setBranchBySelectedCode"
                >
                  <el-option
                    v-for="item in bankBranchList"
                    :key="item.cnapsCode"
                    :label="item.cnapsName"
                    :value="item.cnapsCode"
                  />
                </el-select>
              </el-form-item>
              <template v-if="customWriteBranchBank">
                <el-form-item prop="relationBranchBankName">
                  <el-input
                    v-model="formValues.relationBranchBankName"
                    class="w-[160px] ml-4"
                    clearable
                    autocomplete="nony"
                    placeholder="请输入开户支行名称"
                  />
                </el-form-item>
                <el-form-item prop="cnapsCode">
                  <el-input
                    v-model="formValues.cnapsCode"
                    class="w-[160px] ml-4"
                    clearable
                    autocomplete="nony"
                    placeholder="请输入大额行号"
                  />
                </el-form-item>
              </template>
              <el-button class="top-[-10px] relative ml-4" plain type="warning" @click="toggleCustomStatus">
                {{ !customWriteBranchBank ? '其他支行' : '选择开户支行' }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="base-card-info c-auto">
          <div class="info-card-title">
            账户验证
          </div>
          <el-form-item label="企业支付密码" prop="payPassword">
            <el-input
              v-model="formValues.payPassword"
              class="w-[432px] h-[40px]"
              clearable
              autocomplete="none"
              placeholder="请输入支付密码"
              type="password"
            />
          </el-form-item>
          <el-form-item prop="phoneNo" label="支付手机号">
            <el-input
              v-model="formValues.phoneNo"
              class="w-[432px] h-[40px]"
              clearable
              autocomplete="none"
              placeholder="请输入"
              disabled
            />
          </el-form-item>
          <el-form-item label="验证码" prop="verifyCode">
            <el-input v-model="formValues.verifyCode" placeholder="请输入验证码" class="w-[320px]  h-[40px]" maxlength="6" />
            <sms-button
              ref="smsBtnRef"
              class="!left-[331px]"
              @click="sendSms"
            />
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>

    <div class="pt-[16px]">
      <el-button @click="closeAndBack">
        取消
      </el-button>

      <el-button type="primary" :loading="saveLoading" @click="submitOk">
        确定
      </el-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { AreaSelect, SmsButton } from '@vue3/components';
import { ElMessage, FormInstance, FormRules } from 'element-plus';
import { computed, reactive, ref, toRaw } from 'vue';
import { checkPhone, checkSmsCode } from '@core/tools';
import { bindNewBankAccount, EBankAccountType, getCustomState, IYibaoOpening, queryMasterBanks, queryYibaoBankAccountList, queryYibaoCnapsCodes, useTabsStore, useUserStore, personalBankAccTypes, enterpriseBankAccTypes } from '../../../../..';
import { IMasterBank, IYibaoCnapsCode } from '../../../../../types';
import { ESmsType, sendSmscode } from '@core/api';
const { closeAndBack } = useTabsStore();

defineOptions({ name: 'YibaoChangeBindBank' });

const changeBindState = getCustomState<{id: string;phoneNo: string;from: string}>();

const formRef = ref<FormInstance>();
const source = computed(() => changeBindState.from || 'company');

const queryingMasterBanks = ref(false);
const queryingSubBanks = ref(false);
const allBanks = ref<IMasterBank[]>([]);
const basicBankList = ref<IMasterBank[]>([]);
const bankBranchList = ref<IYibaoCnapsCode[]>([]);

const formValues = ref({} as IYibaoOpening);
const initialAreaCodes = ref<string[]>([]);
const saveLoading = ref(false);

const bankTypeOptions = ref([] as {label: string; value: EBankAccountType}[]);
let sendSmsLock = false;
const smsBtnRef = ref<InstanceType<typeof SmsButton>>(null);

/** 手动填写开户支行名称，开户支行大额行号 */
const customWriteBranchBank = computed(() => formValues.value.customStatus === 'YES');

const { state: userState } = useUserStore();
const isEnterpriseAgent = computed(() => userState.identity.agentDTO?.agentType === 0 ? false : true);
const bankCardNoList = ref([]);

const rules = reactive<FormRules<IYibaoOpening>>({
  bankAccountType: [
    {
      required: true,
      message: isEnterpriseAgent.value ? '请选择银行账户类型' : '请选择企业基本账户类型',
    },
  ],
  bankAccountName: [
    {
      required: true,
      message: '请输入账户名',
    },
  ],
  bankCardNo: [
    {
      required: true,
      message: isEnterpriseAgent.value ? '请输入银行账号' : '请选择企业基本账号', 
    },
    {
      required: true,
      validator: (rule: any, value: string, callback: any) => {
        if (bankCardNoList.value.includes(formValues.value.bankCardNo)) {
          callback(new Error('账号已存在'));
        } 
        callback();
      },
    },
  ],
  bankCode: [
    {
      required: true,
      message: '请选择企业开户银行',
    },
  ],
  bankCityCode: [
    {
      required: true,
      message: '请选择开户城市所在省市',
    },
  ],
  bankBranchNo: [
    {
      required: true,
      message: '输入关键字搜索并选择开户支行',
    },
  ],
  bankBranch: [
    {
      required: true,
      message: '请输入开户支行名称',
      trigger: 'blur',
    },
  ],
  relationBranchBankName: [
    {
      required: true,
      message: '请输入开户支行名称',
    },
  ],
  cnapsCode: [
    {
      required: true,
      message: '请输入大额行号',
    },
  ],
  payPassword: [
    {
      required: true,
      message: '请输入支付密码',
    },
    {
      required: true,
      validator: (rule: any, value: string, callback: any) => {
        if (formValues.value.payPassword.length < 6) {
          callback(new Error('支付密码必须是6-20位'));
        }
        callback();
      },
    },

  ],
  phoneNo: [
    {
      required: true,
      validator: (rule: any, value: string, callback: any) => {
        if (checkPhone(formValues.value.phoneNo, '银行预留')) {
          callback(checkPhone(formValues.value.phoneNo, '银行预留'));
        }
        callback();
      },
    },

  ],
  verifyCode: [
    {
      required: true,
      validator: (rule: any, value: string, callback: any) => {
        if (checkSmsCode(String(formValues.value.verifyCode))) {
          callback(checkSmsCode(String(formValues.value.verifyCode)));
        }
        callback();
      },
    },

  ],
});

/** 查询开户总行列表 */
async function searchMasterBanks(queryString: string, code = '') {
  if (queryString !== undefined && !queryString?.trim()) return;

  queryingMasterBanks.value = true;
  try {
    const d = await queryMasterBanks(queryString || undefined, code || undefined);

    basicBankList.value = d;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message || '查询开户银行列表失败');
  }
  queryingMasterBanks.value = false;
}

async function fetchBankListData() {
  try {
    const { data } = await queryYibaoBankAccountList({
      id: changeBindState.id,
      page: 1,
      size: 100, 
    }, source.value == 'company');

    bankCardNoList.value = data.map((item) => item.bankCardNo) || [];
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function selectBasicBank(bankcode: string) {
  const list = toRaw(allBanks.value);
  const result = list ? list.filter((v) => v.bankCode === bankcode) : [];

  if (result.length > 0) {
    const node = result[0];

    // 开户银行赋值（名称和code）
    formValues.value.bankCode = node.bankCode;
    formValues.value.bankBranch = node.bankName;
  }

  bankBranchList.value = [];
  initialAreaCodes.value = [];
  formValues.value.bankCityCode = '';
  formValues.value.bankProvinceCode = '';

  onCityChange();
}

function onCityChange() {
  resetBranchBanks();
  resetCustomeBankBranch();
  formValues.value.relationBranchBankName = '';
  formValues.value.bankBranch = '';
}

function resetBranchBanks() {
  // 重新查询"开户支行"列表
  bankBranchList.value = [];
  formValues.value.bankBranchNo = '';
}

function resetCustomeBankBranch() {
  formValues.value.cnapsCode = '';
  formValues.value.customBankBranchName = '';
}

async function queryBankBranchSearch(queryString: string, code = '') {
  if (!formValues.value.bankCode) return;
  if (!formValues.value.bankCityCode) return;

  if (queryString !== undefined && !queryString?.trim() && !bankBranchList.value.length) return;
  if (queryString !== undefined && !queryString?.trim()) return;

  const data = {
    cnapsCode: code || undefined,
    cnapsName: queryString || undefined,
    bankCode: formValues.value.bankCode,
    cityCode: formValues.value.bankCityCode,
    provinceCode: formValues.value.bankProvinceCode,
  };

  queryingSubBanks.value = true;
  try {
    bankBranchList.value = await queryYibaoCnapsCodes(data);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message || '查询开户支行列表失败');
  }
  queryingSubBanks.value = false;
}

function setBranchBySelectedCode(code: string) {
  const banks = [...bankBranchList.value];
  const results = banks.filter((v) => v.cnapsCode === code) || [];

  if (results.length > 0) {
    resetCustomeBankBranch();
    formValues.value.bankBranchNo = code;
    formValues.value.bankBranch = results[0].cnapsName;
  }
}

function toggleCustomStatus() {
  const status = formValues.value.customStatus ?? 'NO';

  formValues.value.customStatus = status === 'NO' ? 'YES' : 'NO';
}

function submitOk() {
  formRef.value.validate((valid) => {
    if (valid) doSubmit();
  });
}

function getApiparams() {
  const {
    bankAccountType,
    bankAccountName,
    bankCardNo,
    bankCode,
    bankBranch,
    bankProvinceCode,
    bankCityCode,
    customStatus,
    bankBranchNo,
    cnapsCode,
    payPassword,
    relationBranchBankName,
    verifyCode,
  } = formValues.value;

  return {
    id: Number(changeBindState.id),
    bankAccountType,
    bankAccountName,
    bankCardNo,
    bankCode,
    bankProvinceCode: bankProvinceCode,
    bankCityCode: bankCityCode,
    cnapsCode: customStatus === 'NO' ? bankBranchNo : cnapsCode,
    bankBranch: customStatus === 'NO' ? bankBranch : relationBranchBankName,
    customStatus: customStatus,
    payPassword,
    verifyCode,
  };
}

async function doSubmit() {
  saveLoading.value = true;
  try {
    await bindNewBankAccount(getApiparams(), source.value == 'company');
    ElMessage.success('绑定银行卡成功');
    closeAndBack();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  saveLoading.value = false;
}

async function sendSms() {
  if (!formValues.value.payPassword) return formRef.value?.validateField('payPassword');
  if (sendSmsLock) return;

  const phoneErr = checkPhone(formValues.value.phoneNo, '登录');

  if (phoneErr) return ElMessage.error(phoneErr);

  try {
    sendSmsLock = true;
    smsBtnRef.value?.showLoading();

    await sendSmscode(ESmsType.SplitBill, formValues.value.phoneNo);

    smsBtnRef.value?.countdown();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
    smsBtnRef.value?.hideLoading();
  }

  setTimeout(() => {
    sendSmsLock = false;
  }, 1300);
}

function initOptions() {
  if (isEnterpriseAgent.value) {
    bankTypeOptions.value = personalBankAccTypes;
  } else {
    bankTypeOptions.value = enterpriseBankAccTypes;
  }
}

function init() {
  fetchBankListData();
  initOptions();
  formValues.value = {
    customStatus: 'NO',
    phoneNo: changeBindState.phoneNo, 
  };
}

init();
</script>
<style lang="scss" scoped>
:deep(.el-select__wrapper) {
  height: 40px;
}
</style>

